import { render, staticRenderFns } from "./cashupManageExpenses.vue?vue&type=template&id=71dc8a44&"
import script from "./cashupManageExpenses.vue?vue&type=script&lang=js&"
export * from "./cashupManageExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports